import axios from 'axios';
import authService from './authService';

const API_URL = '/api/analytics/';

// Add a request interceptor to include the auth token
axios.interceptors.request.use(
  (config) => {
    const user = authService.getCurrentUser();
    if (user && user.accessToken && config.url.includes('/analytics/')) {
      config.headers.Authorization = 'Bearer ' + user.accessToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

class AnalyticsService {
  // Get comprehensive analytics dashboard
  getDashboard() {
    return axios.get(API_URL + 'dashboard');
  }

  // Get analytics for specific date range
  getDateRangeAnalytics(startDate, endDate) {
    return axios.get(API_URL + 'date-range', {
      params: {
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString()
      }
    });
  }
}

export default new AnalyticsService();